$(document).ready(function(){
// custom code for minus qty in cart form product grid
$(".custom_plus").on("click",function(){
  $(this).siblings(".atc_with_qty").trigger("click");
  // $(this).siblings(".atc_with_qty").text("Added to cart");
});
  
 $(document).on("click", ".custom_minus", function () {
    var proId = $(this).attr("data-proid"); // Get product ID from the button
    console.log("Product ID:", proId);
    var $this = $(this);
   console.log('$this',$this);
    // Fetch the current cart
    jQuery.getJSON('/cart.js', function (cart) {
        let itemFound = false;

        // Loop through the cart items
        cart.items.forEach(function (item) {
            if (item.id == proId) {
                itemFound = true;

                // Calculate updated quantity
                var cartQty = item.quantity;
                var updatedQty = cartQty - 1;

                  
                  
                // Ensure updated quantity is not less than zero
                if (updatedQty < 0) updatedQty = 0;
                
                // Prepare updates object
                let updates = {};
                updates[item.id] = updatedQty;

                // Update the cart
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ updates }),
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error('Failed to update cart');
                        }
                        return response.json();
                    })
                    .then((data) => {
                      if(updatedQty <= 0){
                        $($this).parent('.ctm_atc_btn').addClass('hide');
                        $($this).parent('.ctm_atc_btn').siblings('.button.atc').removeClass('hide');
                      }

                
                  jQuery.getJSON('/cart.js', function (cart) {
                     cart.items.forEach(function (item) {
                  if (item.id == proId) {
                     var cartQty = item.quantity;
                    $($this).parent('.ctm_atc_btn').find("button").html(cartQty+" Added");
                  }
                     });
                  });
                      
                        console.log('Cart updated successfully:', data);

                        // Optionally refresh the cart UI or trigger custom events
                        document.documentElement.dispatchEvent(
                            new CustomEvent('cart:updated', {
                                bubbles: true,
                                detail: { cart: data },
                            })
                        );

                        // If quantity is 0, optionally refresh or reload the cart
                       
                            document.documentElement.dispatchEvent(
                                new CustomEvent('cart:refresh', {
                                    bubbles: true,
                                    detail: { cart: data, replacementDelay: 600 },
                                })
                            );
                        
                    })
                    .catch((error) => {
                        console.error('Error updating cart:', error);
                    });
            }
        });

        // If item not found in the cart, log an error
        if (!itemFound) {
            console.error("Item with ID", proId, "not found in the cart.");
        }
    });
});

});

var swiper = null;

function initializeSwiper() {
    swiper = new Swiper(".review_blocks_slider", {
        loop: true,
        slidesPerView: 2.5,
        paginationClickable: true,
        spaceBetween: 20,
        breakpoints: {
            1460: {
                slidesPerView: 2.5,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 2.5,
                spaceBetween: 30
            },
            741: {
                slidesPerView: 1,
                spaceBetween: 30
            }
        }
    });
}

$(document).ready(function() {
    initializeSwiper(); // Initialize Swiper on document ready

    // Update Swiper when window is resized
    $(window).on('resize', function() {
        if (swiper !== null) {
            swiper.destroy(true, true); // Destroy Swiper instance
        }
        initializeSwiper(); // Reinitialize Swiper with updated settings
    });
});



$(document).ready(function(){
// $('.cartdrawer-upsell-wrap').slick({
//       dots: false,
//     slidesToShow: 1
//   });
// var isALARendered;
// function ALAcheck() {
//   isALARendered = setInterval(function () {
//     customALA()
//   }, 200);
// }
// ALAcheck();
// function customALA() {
// var selector = $('.cartdrawer-upsell-wrap');
//   if(selector.length > 0) {
//     // clearInterval(isALARendered); 
//     if(!$('.cartdrawer-upsell-wrap').hasClass("slick-initialized")){
//    $('.cartdrawer-upsell-wrap').slick({
//       dots: false,
//     slidesToShow: 1,
//      arrows: true
//   });
//     }
    
//      if($(".cartdrawer-upsell-wrap .upsell-pro-list.ajaxcart__product").length < 1)
//     {
//       $(".upsell_products_drawer").css("display","none");
//     }
//   }  
// }
  
// upsell multiple add in cart-drawer

$(document).on('click', '.addcart-btn',function(){
  var pro_id = $(this).data("pro-id");
  let arr = [];
  arr.push({id: pro_id, quantity: 1 });   
  let formData = {'items': arr};
  fetch('/cart/add.js', {
              body: JSON.stringify(formData),
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With':'xmlhttprequest'
              },
              method: 'POST'
            }).then((response) => {
              return response.json();
            }).then((res) => {
     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
setTimeout(function(){
  
    if($(".cartdrawer-upsell-wrap .upsell-pro-list.ajaxcart__product").length < 1)
    {
      $(".upsell_products_drawer").css("display","none");
    }
  },500);
            if(res.status && res.status == 422){
              console.log("Inventory Error !");
            }else{
              console.log("Success !");
              }
            }).catch((err) => {
              /* uh oh, we have error. */
              console.error(err)
            });
});

});



  // function updateUnitsLeft() {
  //   const min = 50;
  //   const max = 75;
  //   const randomUnits = Math.floor(Math.random() * (max - min + 1)) + min;
  //   document.getElementById('units-left').innerText = `Last ${randomUnits} Units Left`;
  // }
  // updateUnitsLeft();

  // setInterval(updateUnitsLeft, 180000);




  if(document.body.classList.contains('template-product')){
    function toggleAccordion(button) {
    const content = button.nextElementSibling;
    content.classList.toggle('open');
    button.classList.toggle('active');
  }
  }